import React from "react";
import { useLocation } from "react-router-dom";
import { Box, GlobalStyles, useTheme, useMediaQuery } from "@mui/material";
import Sidebar from "./Sidebar";

const DRAWER_WIDTH = 240;

// Rutas públicas/sin navegación: no mostramos el sidebar acá.
const NO_SIDEBAR_ROUTES = [
  "/login",
  "/register",
  "/forgotPassword",
  "/terms",
  "/privacyPolicy",
];

// Layout responsivo:
//  - Mobile: no cambia nada (cada página mantiene su AppBar y su BottomNav).
//  - Desktop (>=900px): aparece un sidebar fijo a la izquierda con todos los
//    botones, y se ocultan las AppBar superiores y la BottomNav (ambas son
//    MuiAppBar) para dejar la navegación solo en el sidebar.
const Layout = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();

  const showSidebar =
    isDesktop && !NO_SIDEBAR_ROUTES.includes(location.pathname);

  return (
    <>
      {showSidebar && (
        <GlobalStyles
          styles={{
            // Oculta headers superiores y la barra inferior en desktop.
            ".MuiAppBar-root": { display: "none !important" },
          }}
        />
      )}

      {showSidebar && <Sidebar width={DRAWER_WIDTH} />}

      <Box sx={{ ml: showSidebar ? `${DRAWER_WIDTH}px` : 0 }}>{children}</Box>
    </>
  );
};

export default Layout;
